import { Link } from 'react-router-dom';

import { useFavoriteMutations } from './useFavoriteMutations';
import { useFavoritesQuery } from './useFavoritesQuery';

export function FavoritesScreen() {
  const { data, isPending, isError, refetch } = useFavoritesQuery();
  const { remove } = useFavoriteMutations();

  if (isPending) {
    return <p className="px-6 py-8 text-text-2">Загрузка избранного…</p>;
  }

  if (isError) {
    return (
      <div className="px-6 py-8">
        <p className="text-danger">Не удалось загрузить избранное. Попробуйте ещё раз.</p>
        <button
          type="button"
          onClick={() => void refetch()}
          className="mt-2 text-sm text-accent hover:underline"
        >
          Повторить
        </button>
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <p className="px-6 py-8 text-text-2">
        Пока нет избранного — добавляйте портреты со страницы результата.
      </p>
    );
  }

  return (
    <ul className="grid grid-cols-2 gap-3 px-6 py-8 sm:grid-cols-3">
      {data.map((entry) => (
        <li key={entry.favoriteId} className="flex flex-col gap-2">
          <Link to={`/result/${entry.generationId}`}>
            {entry.imageUrl ? (
              <img src={entry.imageUrl} alt="" className="aspect-square w-full rounded-card object-cover" />
            ) : (
              <div className="flex aspect-square w-full items-center justify-center rounded-card bg-surface-2 text-xs text-text-3">
                нет фото
              </div>
            )}
          </Link>
          <button
            type="button"
            onClick={() => remove.mutate(entry.favoriteId)}
            disabled={remove.isPending && remove.variables === entry.favoriteId}
            className="text-xs text-danger hover:underline disabled:opacity-50"
          >
            Убрать из избранного
          </button>
        </li>
      ))}
    </ul>
  );
}
